import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import Classes from '../common/Classes';
import ProducerImage from '../common/producer/ProducerImage';
import { Devices, ScreenSizes } from '../common/Constants';


const ProducerDirectoryImage = ({
  src, alt, isRounded, defaultArtistLogoUrl
}) => (
  <div className={Classes.artistDirectoryImageContainer}>
    <MediaQuery minWidth={1199}>
      <ProducerImage
        src={src}
        deviceType={Devices.desktop}
        imageSize={ScreenSizes.large}
        alt={alt}
        isRounded={isRounded}
        defaultArtistLogoUrl={defaultArtistLogoUrl}
      />
    </MediaQuery>
    <MediaQuery minWidth={992} maxWidth={1198}>
      <ProducerImage
        src={src}
        deviceType={Devices.desktop}
        imageSize={ScreenSizes.small}
        alt={alt}
        isRounded={isRounded}
        defaultArtistLogoUrl={defaultArtistLogoUrl}
      />
    </MediaQuery>
    <MediaQuery minWidth={768} maxWidth={991}>
      <ProducerImage
        src={src}
        deviceType={Devices.mobile}
        imageSize={ScreenSizes.large}
        alt={alt}
        isRounded={isRounded}
        defaultArtistLogoUrl={defaultArtistLogoUrl}
      />
    </MediaQuery>
    <MediaQuery maxWidth={767}>
      <ProducerImage
        src={src}
        deviceType={Devices.mobile}
        imageSize={ScreenSizes.small}
        alt={alt}
        isRounded={isRounded}
        defaultArtistLogoUrl={defaultArtistLogoUrl}
      />
    </MediaQuery>
  </div>
);


ProducerDirectoryImage.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  isRounded: PropTypes.bool,
  defaultArtistLogoUrl: PropTypes.string
};

export default ProducerDirectoryImage;
